import * as React from "react";
import { useProvider } from "../Context";
import useApi from "Hooks/useApi";
import useAuth from "Hooks/useAuth";
import { message } from "constants/message";

const initialState = {
  alert_type: "none",
  alert_target: "all",
  alert_tweets: 30,
  is_alert_tweets: true,
  alert_address: "",
  name: "",
  words_or: "",
  words_and: "",
  ignore_case_and: false,
  ignore_case_not: false,
  words_not: "",
  dtm_enable: true,
  dict_posi: [],
  dict_nega: [],
  alert_params: {},
  mentions: false,
  errors: [],
  isError: false,
  errorMsg: "",
  isCreateSuccess: false,
  isEditSuccess: false,
};

function reducer(state, { type, payload }) {
  switch (type) {
    case "set":
      return { ...state, ...payload };
    default:
      throw new Error("Action type not found");
  }
}

export function useGroupSettingReducer() {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  return {
    state,
    dispatch,
  };
}

export default function () {
  const {
    groupSetting: { state, dispatch },
  } = useProvider();
  const { request } = useApi();
  const auth = useAuth();
  const messages = message();

  function setData(key, data) {
    if (data === "true") {
      data = true;
    } else if (data === "false") {
      data = false;
    }
    if (
      key === "unit" ||
      key === "thold" ||
      key === "target" ||
      key === "ratio" ||
      key === "interval"
    ) {
      const alertParams = JSON.parse(JSON.stringify(state.alert_params)) || {};
      alertParams[key] = parseInt(data);
      dispatch({
        type: "set",
        payload: { alert_params: { ...alertParams } },
      });
    } else {
      dispatch({
        type: "set",
        payload: { [key]: data },
      });
    }
  }

  function setErrors(msg) {
    dispatch({
      type: "set",
      payload: { isError: true },
    });
    dispatch({
      type: "set",
      payload: { errorMsg: msg },
    });
  }

  function clearErrors() {
    dispatch({
      type: "set",
      payload: { isError: false },
    });
    dispatch({
      type: "set",
      payload: { errorMsg: "" },
    });
  }

  function clearFlags() {
    dispatch({
      type: "set",
      payload: { isCreateSuccess: false },
    });
    dispatch({
      type: "set",
      payload: { isEditSuccess: false },
    });
  }

  function submit() {
    clearFlags();
    const params = buildParams();
    request({
      method: "POST",
      url: `config/:account_id/groups`,
      data: { ...params },
    })
      .then((data) => {
        clearErrors();
        auth.setGroup(data.data);
        dispatch({
          type: "set",
          payload: { 
            isCreateSuccess: true,
            errors: [] 
          },
        });
      })
      .catch((err) => {
        dispatch({
          type: "set",
          payload: { 
            errors: err.response.data.errors.alert_params,
            isError: true,
            errorMsg: messages.validation.common
          },
        });
      });
  }

  function editSubmit(id) {
    clearFlags();
    const params = buildParams();
    request({
      method: "PUT",
      url: `config/:account_id/groups/${id}`,
      data: { ...params },
    })
      .then((data) => {
        request({
          method: "GET",
          url: "config/:account_id/groups",
        }).then((result) => {
          clearErrors();
          auth.setGroups(result.data, result.meta);
          dispatch({
            type: "set",
            payload: { 
              isEditSuccess: true,
              errors: [] 
            },
          });
        });
      })
      .catch((err) => {
        dispatch({
          type: "set",
          payload: {
            isSuccess: false,
            errors: err.response.data.errors,
            isError: true,
            errorMsg: messages.validation.common
          },
        });
      });
  }

  function buildParams() {
    const params = JSON.parse(JSON.stringify(state));
    params.alert_params = filterdAlertParams(
      params.alert_params,
      params.alert_type
    );
    if (!params.is_alert_tweets) {
      params.alert_tweets = 0;
    }

    params.words_or = params.words_or.split("\n").filter((v) => v);
    params.words_and = params.words_and.split("\n").filter((v) => v);
    params.words_not = params.words_not.split("\n").filter((v) => v);
    params.alert_address = 
      params.alert_address ? 
        params.alert_address.replace(/\r?\n/g , ','): 
        null ;
    delete params.is_alert_tweets;
    delete params.isCreateSuccess;
    delete params.isEditSuccess;
    delete params.errors;

    return params;
  }

  function filterdAlertParams(alertParams, alertType) {
    if (alertType === "none") {
      return null;
    }

    if (alertType === "burst") {
      const { thold, interval, ...filterd } = alertParams;
      return filterd;
    }

    if (alertType === "threshold") {
      const { unit, target, ratio, ...filterd } = alertParams;
      return filterd;
    }

    if (alertType === "count") {
      const { target, ratio, ...filterd } = alertParams;
      return filterd;
    }

    if (alertType === "retweet") {
      const { target, ratio, interval, ...filterd } = alertParams;
      return filterd;
    }

    if (alertType === "follower") {
      const { target, ratio, interval, ...filterd } = alertParams;
      return filterd;
    }
  }

  function setAllData(data) {
    dispatch({
      type: "set",
      payload: {
        ...data,
        ...{
          is_alert_tweets: data.alert_tweets > 0,
          words_and: data.words_and.join("\n"),
          words_not: data.words_not.join("\n"),
          words_or: data.words_or.join("\n"),
        },
      },
    });
  }

  function initialData() {
    dispatch({
      type: "set",
      payload: {
        alert_type: "none",
        alert_target: "all",
        alert_tweets: 30,
        is_alert_tweets: true,
        alert_address: "",
        name: "",
        words_or: "",
        words_and: "",
        ignore_case_and: false,
        ignore_case_not: false,
        words_not: "",
        dtm_enable: true,
        dict_posi: [],
        dict_nega: [],
        errors: [],
        alert_params: {},
        mentions: false,
        isError: false,
        errorMsg: "",
        isCreateSuccess: false,
        isEditSuccess: false,
      },
    });
  }

  return {
    state: state,
    dispatch: dispatch,
    setData,
    setErrors,
    clearFlags,
    clearErrors,
    submit,
    editSubmit,
    setAllData,
    initialData,
  };
}
